<ul class="list-group list-group-flush">
    <ng-template ngFor let-entity [ngForOf]="entities" let-i="index">
        <label for="naturezaVenda_{{indexUnidadeNegocio}}_{{indexMercado}}_{{i}}" class="col-form-label">
            Natureza de Venda
        </label>          
        <li class="list-group-item select">
            <div class="input-group">
                <div class="input-group-prepend delete" *ngIf="canEdit">
                    <button type="button" class="btn btn-light btn-delete" (click)="delete(i)">
                        <i class="far fa-trash-alt" aria-hidden="true"></i>
                    </button>
                </div>
                <select class="form-control" name="naturezaVenda_{{indexUnidadeNegocio}}_{{indexMercado}}_{{i}}" id="naturezaVenda_{{indexUnidadeNegocio}}_{{indexMercado}}_{{i}}" 
                    [ngModel]="entity.idNaturezaVenda || ''" (ngModelChange)="onSelectNaturezaVenda(entity, $event)"
                    #naturezaVenda="ngModel" [disabled]="!canEdit">
                    <option value="">NÃO INFORMADA</option>
                    <optgroup label="ATIVAS" *ngIf="(naturezasVendas | unidadeNegocioNaturezaVendaSituacaoFilter: naturezaVendaSituacaoAtiva)?.length > 0">
                        <option *ngFor="let unidadeNegocioNaturezaVenda of naturezasVendas | unidadeNegocioNaturezaVendaSituacaoFilter: naturezaVendaSituacaoAtiva" [ngValue]="unidadeNegocioNaturezaVenda.idNaturezaVenda">{{unidadeNegocioNaturezaVenda.naturezaVenda?.nome}}</option>
                    </optgroup>
                    <optgroup label="INATIVAS" *ngIf="(naturezasVendas | unidadeNegocioNaturezaVendaSituacaoFilter: naturezaVendaSituacaoInativa)?.length > 0">
                        <option *ngFor="let unidadeNegocioNaturezaVenda of naturezasVendas | unidadeNegocioNaturezaVendaSituacaoFilter: naturezaVendaSituacaoInativa" [ngValue]="unidadeNegocioNaturezaVenda.idNaturezaVenda" disabled>{{unidadeNegocioNaturezaVenda.naturezaVenda?.nome}}</option>
                    </optgroup>                
                </select> 
                <div class="input-group-append">
                    <span class="input-group-text">                
                        <sgt-natureza-venda-situacao-badge
                            [situacao]="entity.situacaoNaturezaVenda">
                        </sgt-natureza-venda-situacao-badge>
                    </span>
                </div>                         
            </div>
    
            <div class="container-children">
                <sgt-cliente-unidade-negocio-item-tipo
                    #itemTipoForm
                    [canEdit]="canEdit"
                    [idCliente]="idCliente"
                    [idUnidadeNegocio]="idUnidadeNegocio"
                    [nomeUnidadeNegocio]="nomeUnidadeNegocio"
                    [indexUnidadeNegocio]="indexUnidadeNegocio"
                    [idMercado]="idMercado"
                    [nomeMercado]="nomeMercado"
                    [indexMercado]="indexMercado"
                    [idNaturezaVenda]="entity.idNaturezaVenda"
                    [nomeNaturezaVenda]="entity.nomeNaturezaVenda"
                    [indexNaturezaVenda]="i"
                    [itensTipos]="itensTipos"
                    [entities]="entity.itensTipos">
                </sgt-cliente-unidade-negocio-item-tipo>
            </div>        
        </li>
    </ng-template>    
    <li class="list-group-item no-entities" *ngIf="!entities || entities.length === 0">
        Nenhuma Natureza de Venda Adicionada
    </li>
    <li class="list-group-item options" *ngIf="canEdit">
        <button type="button" class="btn btn-primary btn-add" (click)="insert()">
            <i class="fas fa-plus" aria-hidden="true"></i> Adicionar Natureza de Venda
        </button>
    </li>
</ul>